import { FormData } from "../type";

export const buildUpdatePoInwardPayload = (data: FormData) => {
    const payload: any = { ...data };

    payload.isRecieved = true;

    const numericFields = [
        'id',
        'purchaseOrderItemMasterId',
        'expectedGoldRate',
        'expectedDiamondRate',
        'expectedMakingRate',
        'standardGoldWeight',
        'standardDiamondWeight',
        'qty',
        'actualGoldWeight',
        'actualDiamondWeight',
        'goldCost',
        'diamondCost',
        'craftsmanshipCost',
        'makingCharges',
        'otherCharges',
        'totalCost',
        'dpPrice',
        'otherWeight',
        'colorStonePrice',
        'purchaseRate',
        'costToCompany',
        'updatedBy',
        'createdBy'
    ];

    numericFields.forEach(field => {
        const key = field as keyof FormData;
        if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {

            if (typeof payload[key] === 'string') {
                payload[key] = parseFloat(payload[key] as string) as any;
            }
        } else {
            payload[key] = 0 as any;
        }
    });

    if (payload.createdOn && typeof payload.createdOn === 'string') {
        payload.createdOn = new Date(payload.createdOn) as any;
    }
    if (payload.updatedOn && typeof payload.updatedOn === 'string') {
        payload.updatedOn = new Date(payload.updatedOn) as any;
    }

    const stringFields = [
        'bagNumber',
        'status',
        'igino',
        'huid',
        'cocdNo',
        'barcode',
        'specialInstructions',
        'invoiceUrl'

    ];

    stringFields.forEach(field => {
        const key = field as keyof FormData;
        if (payload[key] === undefined || payload[key] === null) {
            payload[key] = '' as any;
        }
    });

    if (payload.isSRP !== undefined) {
        payload.isSRP = Boolean(payload.isSRP);
    }
    if (payload.deleted !== undefined) {
        payload.deleted = Boolean(payload.deleted);
    }

    return payload;
};